import {
  Flex,
  LabeledValue,
  View,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"

export function PatientInfo({ id }: {readonly id: number }) {
  const patientName = "Patient"
  const ip = "127.0.0.1"
  const department = "Oncology"
  const ns = "Nursing Station"
  const dataOfArrival = "Arrival"
  const dataOfDeparture = "Departure"
  const wardNumber = "ward"
  const umrNumber = "umr"
  const doctorName = "Doctor"

  return (
    <View backgroundColor="gray-300" paddingX="size-200" paddingY="size-65" height="size-750">
      <Flex direction="row" columnGap={10} wrap>
        <LabeledValue label="ID :" value={id} labelPosition="side" />
        <LabeledValue label="NAME :" value={patientName} labelPosition="side" />
        <LabeledValue label="IP :" value={ip} labelPosition="side" />
        <LabeledValue
          label="DEPARTMENT :"
          value={department}
          labelPosition="side"
        />
        <LabeledValue label="NS :" value={ns} labelPosition="side" />
        <LabeledValue
          label="DOA :"
          value={dataOfArrival}
          labelPosition="side"
        />
        <LabeledValue
          label="DOCTOR :"
          value={doctorName}
          labelPosition="side"
        />
        <LabeledValue label="UMR :" value={umrNumber} labelPosition="side" />
        <LabeledValue label="WN :" value={wardNumber} labelPosition="side" />
        <LabeledValue
          label="DOD :"
          value={dataOfDeparture}
          labelPosition="side"
        />
      </Flex>
    </View>
  )
}
